import { render, staticRenderFns } from "./CodeListItemSimpleCard.vue?vue&type=template&id=62caa115&scoped=true"
import script from "./CodeListItemSimpleCard.vue?vue&type=script&lang=js"
export * from "./CodeListItemSimpleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62caa115",
  null
  
)

export default component.exports